import React from "react";
import Routes from "./Routes";
import { WebsiteDataProvider } from "./context/WebsiteDataContext";

function App() {
  return (
    <WebsiteDataProvider>
      <Routes />
    </WebsiteDataProvider>
  );
}

export default App;
